import Swal, { SweetAlertIcon } from "sweetalert2";
import 'sweetalert2/src/sweetalert2.scss';

export const showWarningDialog = (title: string, description: string, inputPlaceholder?: string) => {
    Swal.fire({ icon: 'warning', title: title, text: description, inputPlaceholder: inputPlaceholder });
}

export const showErrorDialog = (title: string, description: string, inputPlaceholder?: string) => {
    Swal.fire({ icon: 'error', title: title, text: description, inputPlaceholder: inputPlaceholder });
}

export const showSuccessDialog = (title: string, description: string, inputPlaceholder?: string) => {
    Swal.fire({ icon: 'success', title: title, text: description, inputPlaceholder: inputPlaceholder })
}

export const showLoadingDialog = (title: string) => {
    Swal.fire({ imageUrl: '/Content/images/spinner.svg', imageHeight: 50, imageWidth: 50, title: title, showConfirmButton: false })
}

export const showCustomDialog = (title: string, html: any, showCloseButton: boolean, showAnimation: boolean, dialogIcon?: SweetAlertIcon) => {
    Swal.fire({
        icon: dialogIcon,
        title: title,
        html: html,
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: showCloseButton,
        ...(!showAnimation ? {
            showClass: {
                backdrop: 'swal2-noanimation', // disable backdrop animation
                popup: '',                     // disable popup animation
                icon: ''                       // disable icon animation
            },
            hideClass: {
                popup: '',                     // disable popup fade-out animation
            }
        } : {}),

    })
}

export const showConfirmDialog = async (
    title: string,
    description: string,
    confirmButtonText?: string,
    confirmCallback?: () => void,
    cancelCallback?: () => void
) => {
    const result = await Swal.fire({
        icon: 'warning',
        title: title,
        text: description,
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
    });
    if (result?.isConfirmed) {
        confirmCallback?.();
    }
    else {
        cancelCallback?.();
    }
}

export const showInfoDialog = async (
    title: string,
    description: string,
    confirmButtonText?: string,
    confirmCallback?: () => void,
) => {
    const result = await Swal.fire({
        icon: 'info',
        title: title,
        text: description,
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: 'btn btn-info',
        },
        buttonsStyling: false,
        allowOutsideClick: false
    });
    if (result?.isConfirmed) {
        confirmCallback?.();
    }
}

export const getStringInputDialog = async (title: string, defaultValue: string = ''): Promise<string> => {
    const { value } = await Swal.fire({
        title,
        input: 'text',
        inputValue: defaultValue,
        showCancelButton: true
    });

    return value;
}
